import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconStorybook12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconStorybook12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.726 2.606 7.77 1.59l-.004-.007-4.95.31a.45.45 0 0 0-.424.477l.282 7.425a.45.45 0 0 0 .43.435l6.038.27a.45.45 0 0 0 .473-.45v-8.1a.45.45 0 0 0-.48-.45l-.499.038.038 1.035a.068.068 0 0 1-.105.052l-.338-.262-.397.3a.068.068 0 0 1-.11-.057M6.62 4.99v-.002.003zm1.346-.032c-.16.12-1.337.205-1.346.032.022-.674-.278-.7-.447-.7-.153 0-.423.049-.423.413 0 .365.39.571.848.813.65.345 1.44.761 1.44 1.812 0 1.008-.818 1.567-1.865 1.567-1.076 0-2.013-.439-1.912-1.95.045-.18 1.414-.135 1.414 0-.02.626.127.81.487.81.274 0 .394-.15.394-.412 0-.388-.406-.616-.874-.878-.632-.355-1.376-.773-1.376-1.732 0-.964.656-1.61 1.837-1.61 1.178 0 1.823.635 1.823 1.835"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconStorybook12);
